// JsFromRoutes CacheKey 90f18dec638abd173270878b6113d434
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  new: /* #__PURE__ */ definePathHelper('get', '/login'),
  create: /* #__PURE__ */ definePathHelper('post', '/login'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '/logout'),
}
